import * as z from "zod/v4";

export const ConfirmResendReturnLabelSchema = z.object({
  orderId: z.string().nullish(),
  orderEmail: z.string().nullish(),
});

export type ConfirmResendReturnLabel = z.infer<
  typeof ConfirmResendReturnLabelSchema
>;
